export default function PrivacyVelanidiaFarm() {
  return (
    <>
      <div className="container">
        <h1>Privacy policy</h1>
        <p>
          This Privacy Policy applies to the app "Velanidia Farm". This page is
          going to inform you about the collection, use, and disclosure of
          Personal Information while using "Velanidia Farm". If you choose to use
          the app, then you agree to this policy.
        </p>

        <h2>Owner and Data Controller</h2>
        <p>ste aiv</p>
        <p>contact email: steve_aivaATicloud.com</p>

        <h2>Types of Data collected</h2>
        <p>
          We do not collect, store, share, or sell any personal data while you
          are using the app.
        </p>

        <h2>Local storage</h2>
        <p>
          The app allows users to save agriculture actions and notes by month.
          This information is stored locally on the user's device only. The data
          is owned and controlled by the user and is not sent to us or to any
          external server.
        </p>

        <h2>Advertising</h2>
        <p>We do not use any kind of advertisements.</p>

        <h2>Analytics</h2>
        <p>We do not use analytics or tracking tools.</p>

        <h2>External connections</h2>
        <p>
          This app does not use any external API connection. All user data is
          stored on the user's device.
        </p>

        <h2>Children's privacy</h2>
        <p>
          The app is not directed to children. We do not knowingly collect any
          personal information from children.
        </p>

        <h2>Changes to this privacy policy</h2>
        <p>
          We may make changes to this privacy policy in the future. Any change
          will be reflected on this page. It is strongly recommended to check
          this page often, referring to the date of the last modification listed
          at the bottom.
        </p>

        <h4>Latest update: Apr 24, 2026</h4>
      </div>
    </>
  );
}
